// The "do not show again" flag for the install prompt (#330).
//
// It lived inside InstallPwaDialog, which is why nothing could ever clear it:
// the only component that knew the key was the one that set it. One tap on
// "לא להראות הודעה זאת שוב" removed the offer permanently, on that device, with
// no way back from anywhere in the product.
//
// Moving it here is the whole fix for that half — the side menu can now reset it
// when the user goes looking for the install option themselves, which is a
// clearer statement of intent than the checkbox ever was.

const STORAGE_KEY = 'pwaInstallDismissedForever'

export function isInstallDismissedForever() {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

export function setInstallDismissedForever() {
  try {
    localStorage.setItem(STORAGE_KEY, 'true')
  } catch {
    // A browser that refuses storage simply gets the prompt again next time.
  }
}

/** Asking for the install option IS the retraction of "never show me this". */
export function clearInstallDismissal() {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    // ignore
  }
}
